import EventFeedCard from './EventFeedCard';

export default EventFeedCard;
